import { z } from 'zod';
import { EntityWithName, entityWithNameSchema } from './entity-with-name';
import { EntityWithTitle, entityWithTitleSchema } from './entity-with-title';
import { JackpotType, jackpotTypeSchema } from './jackpot-type';

export type AddJackpotResponse = {
	id: number;
	account: EntityWithName;
	game: EntityWithTitle;
	currency: string;
	type: JackpotType;
	betRate: number;
	initialAmount: number;
	limitAmount: number;
	currentAmount: number;
	isLocked: boolean;
};

export const addJackpotResponseSchema: z.ZodType<AddJackpotResponse> = z.object({
	id: z.number(),
	account: entityWithNameSchema,
	game: entityWithTitleSchema,
	currency: z.string(),
	type: jackpotTypeSchema,
	betRate: z.number(),
	initialAmount: z.number(),
	limitAmount: z.number(),
	currentAmount: z.number(),
	isLocked: z.boolean(),
});
